import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './addressAndContactsInitialState';
import {
  _setOrgId,
  _setAddress,
  _setOrgCity,
  _setState,
  _setZip,
  _setCountyId,
  _setSascaRegion,
  _setPostalAddress,
  _setPostalCity,
  _setPostalZip,
  _setCommPhone,
  _setCommFax,
  _setCommEmail,
  _setCommWeb,
} from './addressAndContactsActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAddressAndContactsForm = createAsyncThunk(
  'stop/getAddressAndContactsForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const addressAndContactsSlice = createSlice({
  name: 'stop/addressAndContactsForm',
  initialState,
  reducers: {
    setOrgId: _setOrgId,
    setAddress: _setAddress,
    setOrgCity: _setOrgCity,
    setState: _setState,
    setZip: _setZip,
    setCountyId: _setCountyId,
    setSascaRegion: _setSascaRegion,
    setPostalAddress: _setPostalAddress,
    setPostalCity: _setPostalCity,
    setPostalZip: _setPostalZip,
    setCommPhone: _setCommPhone,
    setCommFax: _setCommFax,
    setCommEmail: _setCommEmail,
    setCommWeb: _setCommWeb,
    resetAddressAndContactsForm: (state) => initialState,
  },
  extraReducers: {
    [getAddressAndContactsForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setOrgId,
  setAddress,
  setOrgCity,
  setState,
  setZip,
  setCountyId,
  setSascaRegion,
  setPostalAddress,
  setPostalCity,
  setPostalZip,
  setCommPhone,
  setCommFax,
  setCommEmail,
  setCommWeb,
  resetAddressAndContactsForm,
} = addressAndContactsSlice.actions;

export default addressAndContactsSlice.reducer;
